import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Header from "../../Common/Header";

const ExecutorIntro1 = () => {
  return (
    <>
      <Header />
      <div className="container">
        <div className="grid grid-cols-2 mt-[30px] max-lg:grid-cols-1">
          <div>
            <div>
              <p className="text-[35px] font-semibold">What is an executor?</p>
              <p className="my-3 text-slate-500">
                Your executors will be in charge of carrying out the wishes in
                your will after you die.
              </p>
              <p className="my-3 text-slate-500">
                This can be difficult and time-consuming. They will need to
                access your accounts, make sure your taxes and debts are paid,
                apply for the proper grants and arrange for all your money,
                property and belongings to be given to the right people. So,
                it’s important to choose your executors carefully.
              </p>
            </div>
            <p className="my-1 text-slate-500"></p>
            <div className="mt-[50px]">
              <p className="text-[35px] font-semibold">
                Who can be an executor?
              </p>
              <p className="my-3 text-slate-500">
                Your executors will be liable for any mistakes made when
                settling your estate, so make sure they are prepared for this.
                That’s one reason why two-thirds of people who write their will
                choose a professional executor to do it.
              </p>
              <p className="my-3 text-slate-500">
                However, you can choose a friend or family member as well - or
                instead. We’ll break down the different options on the next
                page.
              </p>
            </div>
            <div className="border-b-2 my-5"></div>
            <div className="pt-5 flex justify-between items-center">
              <div className="flex  pb-5">
                <Link to={"/dashboard"}>
                  <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                    <FaAngleLeft />
                    Back
                  </button>
                </Link>
              </div>
              <div className="flex  pb-5">
                <Link to={"/make-will-online/executors/intro-2"}>
                  <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                    Next <FaChevronRight />
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div>
            <div className="max-lg:hidden bg-no-repeat ">
              <div className="fixed top-[100px] w-[500px] right-[6%]">
                <img src="/assets/images/10.png" alt="mascot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExecutorIntro1;
